import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ReportService } from 'mapfre-auditlib';
import * as _ from 'lodash';


@Injectable({
  providedIn: 'root'
})
export class SummaryService {

  className = 'SummaryService';

  constructor(private http: HttpClient, private reportService: ReportService) {
  }

  getSummary(params): Observable<any> {
    return this.reportService.getFilteredReports(params).pipe(map((res: any) => {
      let factsRegistry = [];
      let summaryItems = _.map(res.content, (report: any) => {
        let summaryItem: any = {};
        let recommendationsCount = 0;
        let recommendationsCountToCard = 0;
        let allActionPlansCompleted = false;
        let hasActionPlans = false;
        let actionPlans = {};
        let recommendations = {};
        _.forEach(_.get(report, 'facts'), f => {
          let isInRegistry = _.find(factsRegistry, id => id == _.get(f, 'idFactObserverPk'))
          recommendationsCountToCard += _.get(f, 'recommendation.length', 0);
          allActionPlansCompleted = _.every(f.recommendation, r => _.get(r, 'actionPlan.executionDate'));
          hasActionPlans = _.some(f.recommendation, r => _.get(r, 'actionPlan'));
          if (!isInRegistry) {
            _.forEach(f.recommendation, r => {
              let statusRecommendationName = _.get(r, 'status.txtTypeStatusRecommendation');
              if (!recommendations[statusRecommendationName]) {
                recommendations[statusRecommendationName] = 0
              }
              recommendations[statusRecommendationName]++;
              recommendationsCount++;

              if (report.isReviewed || report.status.txtName === "DEFINITIVO") {
                let statusActionPlanName = _.get(r, 'actionPlan.status.txtTypeStatusActionPlan');
                if (!actionPlans[statusActionPlanName]) {
                  actionPlans[statusActionPlanName] = 0;
                }
                actionPlans[statusActionPlanName]++;
              }
            })

            factsRegistry.push(_.get(f, 'idFactObserverPk'));
          }
        })
        summaryItem.report = report;
        summaryItem.recommendationsCount = recommendationsCount;
        summaryItem.recommendationsCountToCard = recommendationsCountToCard;
        summaryItem.allActionPlansCompleted = allActionPlansCompleted;
        summaryItem.hasActionPlans = hasActionPlans;
        summaryItem.actionPlans = actionPlans;
        summaryItem.recommendations = recommendations;
        return summaryItem;
      })
      return { content: summaryItems, totalElements: res.totalElements };
    }))
  }
}
